<template>
  <div class="container-fluid im-fluid" @click="handleHideMenu">
    <div class="row">
      <div class="col-12 col-sm-12 col-xl-6">
        <h2 class="im-title">{{ $t("job.free_positions_title") }}</h2>

        <div id="accordion" class="im-accordion" role="tablist">
          <div ref="collapseWrapper2" class="card">
            <div id="jobTwo" class="card-header" role="tab">
              <h5 class="mb-0">
                <a
                  ref="appDescription2"
                  class="collapsed"
                  data-bs-toggle="collapse"
                  href="#collapseJobTwo"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseJobTwo"
                  @click="openJobId($event, 2)"
                >
                  {{ getJobName(2) }} <i class="float-end fas angle-left"></i>
                </a>
              </h5>
            </div>
            <div
              id="collapseJobTwo"
              class="collapse"
              role="tabpanel"
              aria-labelledby="jobTwo"
              data-parent="#accordion"
            >
              <div class="card-body">
                <p>
                  {{ $t("job.requirements_title") }}
                </p>

                <p v-html="$t('job.position_2_requirements')"></p>

                <p>
                  {{ $t("job.advantages_title") }}
                </p>

                <p v-html="$t('job.position_2_advantages')"></p>

                <p>
                  {{ $t("job.qualities_title") }}
                </p>

                <p v-html="$t('job.position_2_qualities')"></p>

                <p>
                  {{ $t("job.position_2_note") }}
                </p>
              </div>
            </div>
          </div>
          <div ref="collapseWrapper1" class="card">
            <div id="jobOne" class="card-header" role="tab">
              <h5 class="mb-0">
                <a
                  ref="appDescription1"
                  class="collapsed"
                  data-bs-toggle="collapse"
                  href="#collapseJobOne"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseJobOne"
                  @click="openJobId($event, 1)"
                >
                  {{ getJobName(1) }} <i class="float-end fas angle-left"></i>
                </a>
              </h5>
            </div>

            <div
              id="collapseJobOne"
              class="collapse"
              role="tabpanel"
              aria-labelledby="jobOne"
              data-parent="#accordion"
            >
              <div class="card-body">
                <p>{{ $t("job.requirements_title") }}</p>

                <p v-html="$t('job.position_1_requirements')"></p>

                <p>
                  {{ $t("job.qualities_title") }}
                </p>

                <p v-html="$t('job.position_1_qualities')"></p>

                <p>
                  {{ $t("job.position_1_note") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-lg-8 col-xl-6 pt-5 pt-xl-0">
        <h2 class="im-title">{{ $t("job.application_form_title") }}</h2>

        <div>
          <StatusMessage ref="statusMessageSuccess"></StatusMessage>

          <div ref="eleJobName" class="mb-3">
            <label for="jobPosition">{{ $t("job.position") }}: *</label>
            <select
              id="jobPosition"
              v-model.trim="jobId"
              class="form-control"
              @change="toggleAppDescription($event)"
            >
              <option value="">{{ $t("common.select_option") }}</option>
              <option value="2">{{ $t("job.position_laravel_full") }}</option>
              <option value="1">{{ $t("job.position_symfony_full") }}</option>
            </select>
          </div>
          <StatusMessage ref="statusMessageJobName"></StatusMessage>

          <div ref="eleName" class="mb-3 required">
            <label for="name">{{ $t("job.name") }}: *</label>
            <input
              id="name"
              v-model.trim="jobApp_name"
              type="text"
              class="form-control"
              :placeholder="$t('job.name_placeholder')"
              required
            />
          </div>
          <StatusMessage ref="statusMessageName"></StatusMessage>

          <div ref="eleEmail" class="mb-3 required">
            <label for="email">{{ $t("job.email") }}: *</label>
            <input
              id="email"
              v-model.trim="jobApp_email"
              type="email"
              class="form-control"
              placeholder="name@example.com"
              required
            />
          </div>
          <StatusMessage ref="statusMessageEmail"></StatusMessage>

          <div ref="elePhone" class="mb-3">
            <label for="phone">{{ $t("job.phone") }}: *</label>
            <input
              id="phone"
              v-model.trim="jobApp_phone"
              type="tel"
              class="form-control"
              placeholder="+359..."
              required
            />
          </div>
          <StatusMessage ref="statusMessagePhone"></StatusMessage>

          <div ref="eleMotivation" class="mb-3">
            <label for="motivation">{{ $t("job.why_apply") }}: *</label>
            <textarea
              id="motivation"
              v-model.trim="jobApp_motivation"
              class="form-control"
              rows="5"
              required
            ></textarea>
          </div>
          <StatusMessage ref="statusMessageMotivation"></StatusMessage>

          <div ref="eleGitLink" class="mb-3">
            <label for="link">{{ $t("partnership.git_link") }}:</label>
            <input
              id="link"
              v-model.trim="jobApp_git"
              type="url"
              class="form-control"
              placeholder="https://"
            />
          </div>
          <StatusMessage ref="statusMessageGitLink"></StatusMessage>

          <div class="mb-3 mb-0 required">
            <label>{{ $t("job.cv_formats") }}</label>
          </div>

          <div class="input-group mb-3 required">
            <div class="custom-file">
              <input id="file" ref="cvFile" type="file" required @change="fileSetName($event)" />
              <label for="file" class="custom-file-label" v-text="file"></label>
            </div>
          </div>
          <StatusMessage ref="statusMessageFile"></StatusMessage>

          <div class="mb-3 text-sm-center">
            <ReCaptcha ref="recaptcha"></ReCaptcha>
          </div>
          <StatusMessage ref="statusMessageRobot"></StatusMessage>

          <button
            type="button"
            class="btn btn-primary btn-block"
            :class="{ disabled: submitDisabled }"
            @click="jobApp_Submit"
          >
            {{ $t("job.send") }}
          </button>

          <StatusMessage ref="statusMessageSubmit"></StatusMessage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StatusMessage from "../shared/StatusMessage.vue";
  import ReCaptcha from "./ReCaptcha.vue";

  export default {
    name: "JobApplicationSection",
    components: {
      StatusMessage,
      ReCaptcha,
    },
    data() {
      return {
        jobId: "",

        jobApp_name: "",
        jobApp_email: "",
        jobApp_phone: "",
        jobApp_motivation: "",
        jobApp_git: "",

        fileDefault: "Choose file",
        file: "",

        fileTypesAllowed: [
          "application/pdf", // pdf
          "application/vnd.oasis.opendocument.spreadsheet", // .ods
        ],

        submitDisabled: false,

        doScroll: true, // scroll the page when asked or not
      };
    },
    created() {
      this.fileDefault = this.$t("common.choose_file");
      this.file = this.fileDefault;
    },
    unmounted() {
      // Access global property directly in Vue 3
      if (this.$jobApplication) {
        this.$jobApplication.open = "";
      }
    },
    mounted() {
      // Access global property directly in Vue 3
      if (this.$jobApplication) {
        this.jobId = this.$jobApplication.open;
        if (this.jobId !== "") {
          this.$refs["appDescription" + this.jobId].click();
        }
      }
    },
    methods: {
      handleHideMenu() {
        // Access global hideMenu function
        if (this.hideMenu) {
          this.hideMenu();
        }
      },
      toggleAppDescription(event) {
        this.doScroll = false; // do not scroll the page in this case

        if (event.target.value == "" && this.$jobApplication && this.$jobApplication.open !== "") {
          this.$refs["appDescription" + this.$jobApplication.open].click();
        }

        if (event.target.value !== "") {
          this.$refs["appDescription" + event.target.value].click();
        }

        this.jobId = event.target.value;
        if (this.$jobApplication) {
          this.$jobApplication.open = event.target.value;
        }
      },
      jobApp_Send(formData) {
        this.$root.request
          .post("/jobapplication/freepositions", formData)
          .catch(this.$root.responseErrorHandler)
          .then(this.$root.responseMiddleware)
          .then((response) => {
            // console.dir(response);

            this.submitDisabled = false;

            if (response.success) {
              this.$root.scrollToTop();
              this.$refs.statusMessageSuccess.displaySuccessMessage("job_app_sent");
              this.resetForm();
            } else if (response.error && response.error.message) {
              this.$refs.statusMessageSubmit.displayErrorMessage(response.error.message);
            }
          });
      },
      jobApp_Submit() {
        if (this.submitDisabled) {
          return;
        }

        if (this.jobId == "") {
          this.scrollTo("eleJobName");
          this.$refs.statusMessageJobName.displayErrorMessage("required", {
            attribute: this.$t("job.position"),
          });
          return;
        }
        this.$refs.statusMessageJobName.resetStatusMessage();

        if (this.jobApp_name.length < 3) {
          this.scrollTo("eleName");
          this.$refs.statusMessageName.displayErrorMessage("required", {
            attribute: this.$t("job.name"),
          });
          return;
        }
        this.$refs.statusMessageName.resetStatusMessage();

        if (this.jobApp_email.length < 6) {
          this.scrollTo("eleEmail");
          this.$refs.statusMessageEmail.displayErrorMessage("required", {
            attribute: this.$t("job.email"),
          });
          return;
        }
        if (!this.$root.isEmailValid(this.jobApp_email)) {
          this.scrollTo("eleEmail");
          this.$refs.statusMessageEmail.displayErrorMessage("invalid_email");
          return;
        }
        this.$refs.statusMessageEmail.resetStatusMessage();

        if (this.jobApp_phone.length < 6) {
          this.scrollTo("elePhone");
          this.$refs.statusMessagePhone.displayErrorMessage("required", {
            attribute: this.$t("job.phone"),
          });
          return;
        }
        this.$refs.statusMessagePhone.resetStatusMessage();

        if (this.jobApp_motivation.length == 0) {
          this.scrollTo("eleMotivation");
          this.$refs.statusMessageMotivation.displayErrorMessage("required", {
            attribute: this.$t("job.why_apply"),
          });
          return;
        }
        this.$refs.statusMessagePhone.resetStatusMessage();

        // GitHub/BitBucket url
        if (this.jobApp_git.length > 0) {
          var isValidGitUrl = this.$root.isValidGitUrl(this.jobApp_git);
          if (!isValidGitUrl) {
            this.scrollTo("eleGitLink");
            this.$refs.statusMessageGitLink.displayErrorMessage("invalid_git_link");
            return;
          }
        }
        this.$refs.statusMessageGitLink.resetStatusMessage();

        // CV File
        if (this.$refs.cvFile.files.length == 0) {
          this.$refs.statusMessageFile.displayErrorMessage("required", {
            attribute: "CV",
          });
          return;
        }
        if (this.fileTypesAllowed.indexOf(this.$refs.cvFile.files[0].type) < 0) {
          this.$refs.statusMessageFile.displayErrorMessage("file");
          return;
        }

        // ReCaptcha
        if (
          typeof this.$refs.recaptcha.verifyKey !== "string" ||
          this.$refs.recaptcha.verifyKey.length < 200
        ) {
          this.$refs.recaptcha.resetRecaptcha();
          this.$refs.statusMessageRobot.displayErrorMessage("recaptcha");
          return;
        }

        // Form Data
        var uploadData = new FormData();
        uploadData.set("jobApp_app", this.getJobName(this.jobId));
        uploadData.set("jobApp_name", this.jobApp_name);
        uploadData.set("jobApp_email", this.jobApp_email);
        uploadData.set("jobApp_phone", this.jobApp_phone);
        uploadData.set("jobApp_motivation", this.jobApp_motivation);
        uploadData.set("jobApp_git", this.jobApp_git);
        uploadData.set("jobApp_cv", this.$refs.cvFile.files[0]);
        uploadData.set("jobApp_recaptcha", this.$refs.recaptcha.verifyKey);

        this.submitDisabled = true;

        this.jobApp_Send(uploadData);
      },
      fileSetName(event) {
        if (event.target.files.length > 0) {
          if (this.fileTypesAllowed.indexOf(event.target.files[0].type) < 0) {
            this.file = this.fileDefault;
            this.$refs.statusMessageFile.displayErrorMessage("file");
          } else {
            this.file = event.target.files[0].name;
            this.$refs.statusMessageFile.resetStatusMessage();
          }
        } else {
          this.file = this.fileDefault;
          this.$refs.statusMessageFile.resetStatusMessage();
        }
      },
      scrollTo(refName) {
        var rect = this.$refs[refName].getBoundingClientRect();
        this.$root.scrollTo(0, window.scrollY + rect.top - 16);
      },
      getJobName(id) {
        const jobs = {
          1: this.$t("job.position_symfony_full"),
          2: this.$t("job.position_laravel_full"),
        };
        return jobs[id.toString()] || "";
      },
      openJobId(event, id) {
        if (this.jobId != id) {
          this.jobId = id;
          if (this.$jobApplication) {
            this.$jobApplication.open = id;
          }

          if (this.doScroll) {
            window.setTimeout(this.scrollTo.bind(this, "collapseWrapper" + id), 10);
          }
        } else if (-1 == this.$refs["appDescription" + id].className.indexOf("collapse")) {
          this.jobId = "";
        }

        this.doScroll = true;
      },
      isJobHidden(id) {
        if (this.jobId == id) {
          return false;
        }
        return true;
      },
      resetFileInput() {
        this.$refs.cvFile.value = "";
        this.$refs.cvFile.type = "text";
        this.$refs.cvFile.type = "file";
      },
      resetForm() {
        this.jobId = "";
        this.jobApp_name = "";
        this.jobApp_email = "";
        this.jobApp_phone = "";
        this.jobApp_motivation = "";
        this.jobApp_git = "";

        // tricky reset of the file input field
        this.resetFileInput();

        this.$refs.recaptcha.resetRecaptcha();

        this.file = this.fileDefault;
      },
    },
  };
</script>
